/* eslint-disable react/prop-types */
import React, { memo, useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";
import DatePicker from "react-flatpickr";
import SoftDatePicker from "components/SoftDatePicker";
import { item } from "examples/Sidenav/styles/sidenavItem";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  minWidth: 100,
  fontSize: 13,
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
};

const Td = ({ children, style, ...rest }) => {
  return (
    <td {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </td>
  );
};

function TaxPersonalTable({ setFieldValue }) {
  const [data, setData] = useState({
    muc1: [
      {
        id: uuidV4(),
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
        value10: "",
        value11: "",
        value12: "",
        value13: "",
        value14: "",
        value15: "",
        value16: "",
        value17: "",
      },
    ],
    muc2: [
      {
        id: uuidV4(),
        value2: "",
        value3: "",
        value4: "",
        value5: "",
        value6: "",
        value7: "",
        value8: "",
        value9: "",
        value10: "",
        value11: "",
        value12: "",
        value13: "",
        value14: "",
        value15: "",
        value16: "",
        value17: "",
      },
    ],
  });

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { name, value, id, rowType } = values;
    setData((prev) => ({
      ...prev,
      [rowType]: prev[rowType]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleChangeValue = (type, id, name, value) => {
    setData((prev) => ({
      ...prev,
      [type]: prev[type]?.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      }),
    }));
  };

  const handleAdd = (type) => {
    const newRow = {
      id: uuidV4(),
      value2: "",
      value3: "",
      value4: "",
      value5: "",
      value6: "",
      value7: "",
      value8: "",
      value9: "",
      value10: "",
      value11: "",
      value12: "",
      value13: "",
      value14: "",
      value15: "",
      value16: "",
      value17: "",
    };
    setData((prev) => ({ ...prev, [type]: [...prev[type], newRow] }));
  };

  const handleDelete = (type, id) => {
    setData((prev) => ({ ...prev, [type]: prev[type].filter((item) => item.id !== id) }));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td
                colSpan={17}
                style={{ textAlign: "left", background: "#f4f4f4", fontWeight: "bold" }}
              >
                I. Đăng ký cấp mã số thếu cho người phụ thuộc
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc1")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                rowSpan={3}
                style={{
                  textAlign: "center",
                  background: "#f4f4f4",
                  fontWeight: "bold",
                  minWidth: 200,
                }}
              >
                Họ và tên người nộp thuế(*)
              </Td>
              <Td
                rowSpan={3}
                style={{
                  textAlign: "center",
                  background: "#f4f4f4",
                  fontWeight: "bold",
                  minWidth: 100,
                }}
              >
                MST của người nộp thuế
              </Td>
              <Td
                rowSpan={3}
                style={{
                  textAlign: "center",
                  background: "#f4f4f4",
                  fontWeight: "bold",
                  minWidth: 100,
                }}
              >
                Họ và tên người phụ thuộc
              </Td>
              <Td
                rowSpan={3}
                style={{
                  textAlign: "center",
                  background: "#f4f4f4",
                  fontWeight: "bold",
                  minWidth: 100,
                }}
              >
                Ngày sinh người phụ thuộc
              </Td>
              <Td
                rowSpan={3}
                style={{
                  textAlign: "center",
                  background: "#f4f4f4",
                  fontWeight: "bold",
                  minWidth: 100,
                }}
              >
                MST của người phụ thuộc
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Quốc tịch của người phụ thuộc
              </Td>
              <Td
                rowSpan={3}
                style={{
                  textAlign: "center",
                  background: "#f4f4f4",
                  fontWeight: "bold",
                  minWidth: 150,
                }}
              >
                CMND/Hộ chiếu/Số định danh cá nhân của NPT
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Quan hệ với người nộp thuế
              </Td>
              <Td
                rowSpan={1}
                colSpan={6}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Thông tin trên giấy khai sinh của người phụ thuộc (Nếu người phụ thuộc không có
                MST,CMND và Hộ chiếu)
              </Td>
              <Td
                rowSpan={2}
                colSpan={2}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Thời gian tính giảm trừ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold", minWidth: 100 }}>
                Sổ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold", minWidth: 100 }}>
                Quyển sổ
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center", fontWeight: "bold" }}>
                Nơi đăng ký
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quốc gia</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Tình/Thành phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quận/ Huyện</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Phường/ Xã</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", minWidth: 100 }}>Từ tháng</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold", minWidth: 100 }}>Đến tháng</Td>
            </tr>
            {data.muc1.map((item, index) => (
              <tr key={item.id}>
                <Td className="toggle-button" style={{ textAlign: "center", fontWeight: "bold" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc1", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                    type="text"
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    type="text"
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value4"
                    value={item?.value4}
                    onChange={handleChange}
                    type="text"
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value5"
                    value={item?.value5}
                    onChange={handleChange}
                    type="text"
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value6}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value7", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    type="text"
                    name="value8"
                    value={item.value8}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value9", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value10"
                    value={item.value10}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value11"
                    value={item.value11}
                    onChange={handleChange}
                    id={item.id}
                    rowType="muc1"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value12", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value13", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value14", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc1", item.id, "value15", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <SoftDatePicker
                    options={{
                      dateFormat: "m-YY",
                      plugins: [
                        new monthSelectPlugin({
                          shorthand: true,
                          dateFormat: "m/Y",
                          theme: "light",
                        }),
                      ],
                    }}
                    onChange={(e) => handleChange("muc1", item.id, "value16", new Date(e?.[0]))}
                    name="value16"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <SoftDatePicker
                    options={{
                      dateFormat: "m-YY",
                      plugins: [
                        new monthSelectPlugin({
                          shorthand: true,
                          dateFormat: "m/Y",
                          theme: "light",
                        }),
                      ],
                    }}
                    onChange={(e) => handleChange("muc1", item.id, "value17", new Date(e?.[0]))}
                    name="value17"
                  />
                </Td>
              </tr>
            ))}

            <tr>
              <Td
                colSpan={17}
                style={{ textAlign: "left", background: "#f4f4f4", fontWeight: "bold" }}
              >
                II. Đăng ký thay đổi về người phụ thuộc
              </Td>
            </tr>
            <tr>
              <Td
                className="toggle-button"
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                STT
                <div className="button-action">
                  <button type="button" onClick={() => handleAdd("muc2")}>
                    Thêm dòng
                  </button>
                </div>
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Họ và tên người nộp thuế(*)
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                MST của người nộp thuế
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Họ và tên người phụ thuộc
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Ngày sinh người phụ thuộc
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                MST của người phụ thuộc
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Quốc tịch của người phụ thuộc
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                CMND/Hộ chiếu/Số định danh cá nhân của NPT
              </Td>
              <Td
                rowSpan={3}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Quan hệ với người nộp thuế
              </Td>
              <Td
                rowSpan={1}
                colSpan={6}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Thông tin trên giấy khai sinh của người phụ thuộc (Nếu người phụ thuộc không có
                MST,CMND và Hộ chiếu)
              </Td>
              <Td
                rowSpan={2}
                colSpan={2}
                style={{ textAlign: "center", background: "#f4f4f4", fontWeight: "bold" }}
              >
                Thời gian tính giảm trừ
              </Td>
            </tr>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Sổ
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", fontWeight: "bold" }}>
                Quyển sổ
              </Td>
              <Td rowSpan={1} colSpan={4} style={{ textAlign: "center", fontWeight: "bold" }}>
                Nơi đăng ký
              </Td>
            </tr>
            <tr>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quốc gia</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Tình/Thành phố</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Quận/ Huyện</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Phường/ Xã</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Từ tháng</Td>
              <Td style={{ textAlign: "center", fontWeight: "bold" }}>Đến tháng</Td>
            </tr>

            {data.muc2.map((item, index) => (
              <tr key={index}>
                <Td className="toggle-button" style={{ textAlign: "center", fontWeight: "bold" }}>
                  {index + 1}
                  <div className="button-action delete">
                    <button type="button" onClick={() => handleDelete("muc2", item.id)}>
                      Xóa dòng
                    </button>
                  </div>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value2"
                    value={item.value2}
                    onChange={handleChange}
                    type="text"
                    rowType="muc2"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value3"
                    value={item.value3}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    name="value4"
                    value={item.value4}
                    onChange={handleChange}
                    type="text"
                    rowType="muc2"
                    id={item.id}
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value5}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <InputTable
                    id={item.id}
                    name="value6"
                    value={item.value6}
                    onChange={handleChange}
                    rowType="muc2"
                    type="text"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value7}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value8}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <select
                    style={selectStyle}
                    onChange={(e) => handleChangeValue("muc2", item.id, "value9", e.target.value)}
                  >
                    <option value="value1">value1</option>
                    <option value="value2">value2</option>
                  </select>
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value10}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value11}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value12}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value13}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value14}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold", background: "#ddeff3" }}>
                  {item.value15}
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <SoftDatePicker
                    options={{
                      dateFormat: "m-YY",
                      plugins: [
                        new monthSelectPlugin({
                          shorthand: true,
                          dateFormat: "m/Y",
                          theme: "light",
                        }),
                      ],
                    }}
                    onChange={(e) =>
                      handleChangeValue("muc2", item.id, "value16", new Date(e?.[0]))
                    }
                    name="value16"
                  />
                </Td>
                <Td style={{ textAlign: "center", fontWeight: "bold" }}>
                  <SoftDatePicker
                    options={{
                      dateFormat: "m-YY",
                      plugins: [
                        new monthSelectPlugin({
                          shorthand: true,
                          dateFormat: "m/Y",
                          theme: "light",
                        }),
                      ],
                    }}
                    onChange={(e) =>
                      handleChangeValue("muc2", item.id, "value17", new Date(e?.[0]))
                    }
                    name="value17"
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

export default memo(TaxPersonalTable);

function InputTable(props) {
  const { onChange, type = "text", name, id, rowType, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (type === "text") {
      onChange({ value, name, type, id, rowType });
    } else {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, type, id, rowType });
    }
  }
  return (
    <input
      type={type}
      name={name}
      style={{
        textAlign: type === "text" ? "left" : "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.2rem 0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
